import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import FundContentEditor from './admin/FundContentEditor';
import DomainManager from './admin/DomainManager';
import UsersEditor from './admin/UsersEditor';
import AnnouncementsEditor from './admin/AnnouncementsEditor';
import ResourcesEditor from './admin/ResourcesEditor';
import BulkReportsGenerator from './admin/BulkReportsGenerator';
import FaqEditor from './admin/FaqEditor';
import ICREditor from './admin/ICREditor';
import FeeCalculatorEditor from './admin/FeeCalculatorEditor';
import EmailListsEditor from './admin/EmailListsEditor';
import FeedbackManager from './admin/FeedbackManager';
import CpdEditor from './admin/CpdEditor';
import DisclaimersEditor from './admin/DisclaimersEditor';

const AdminPanel = () => {
  const { user } = useAuth();
  // Allow deep-linking to a specific tab via ?tab=<key> (e.g. /admin?tab=icr).
  const [activeTab, setActiveTab] = useState(() => {
    const t = new URLSearchParams(window.location.search).get('tab');
    return t || 'users';
  });

  // Only Drummond users can access admin
  if (!user?.is_drummond_user) {
    return <Navigate to="/dashboard" replace />;
  }

  const SidebarButton = ({ tab, label }) => (
    <button
      className={`list-group-item list-group-item-action ${activeTab === tab ? 'active' : ''}`}
      onClick={() => setActiveTab(tab)}
    >
      {label}
    </button>
  );

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-2">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">Admin Panel</h5>
            </div>
            <div className="list-group list-group-flush">
              <div className="list-group-item fw-bold text-uppercase small" style={{ backgroundColor: '#072040', color: '#fff', letterSpacing: '0.05em' }}>
                Client
              </div>
              <SidebarButton tab="email-lists" label="Email Lists" />
              <SidebarButton tab="announcements" label="Announcements" />
              <SidebarButton tab="resources" label="Resources" />
              <SidebarButton tab="faq" label="FAQ" />
              <SidebarButton tab="feedback" label="Feedback" />
              <SidebarButton tab="cpd" label="CPD" />
              <SidebarButton tab="users" label="Users & Activity" />
              <SidebarButton tab="domain-manager" label="Domain Manager" />
              <SidebarButton tab="fee-calculator" label="Fee Calculator" />
              <SidebarButton tab="disclaimers" label="Disclaimers" />

              <div className="list-group-item fw-bold text-uppercase small" style={{ backgroundColor: '#072040', color: '#fff', letterSpacing: '0.05em' }}>
                Investments
              </div>
              <SidebarButton tab="fund-content" label="Fund Content" />
              <SidebarButton tab="bulk-reports" label="Bulk Reports" />
              <SidebarButton tab="icr" label="ICR Management" />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="col-md-10">
          {activeTab === 'announcements' && <AnnouncementsEditor />}

          {activeTab === 'email-lists' && <EmailListsEditor />}

          {activeTab === 'resources' && <ResourcesEditor />}

          {activeTab === 'faq' && <FaqEditor />}

          {activeTab === 'feedback' && <FeedbackManager />}

          {activeTab === 'cpd' && <CpdEditor />}

          {activeTab === 'fund-content' && <FundContentEditor />}

          {activeTab === 'bulk-reports' && <BulkReportsGenerator />}

          {activeTab === 'domain-manager' && <DomainManager />}

          {activeTab === 'icr' && <ICREditor />}

          {activeTab === 'fee-calculator' && <FeeCalculatorEditor />}

          {activeTab === 'disclaimers' && <DisclaimersEditor />}

          {activeTab === 'users' && <UsersEditor />}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
